/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendTipNotificationActionData
 */
export interface SendTipNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof SendTipNotificationActionData
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof SendTipNotificationActionData
     */
    senderUserId: string;
    /**
     * 
     * @type {string}
     * @memberof SendTipNotificationActionData
     */
    receiverUserId: string;
    /**
     * 
     * @type {string}
     * @memberof SendTipNotificationActionData
     */
    tipTxSignature: string;
}

/**
 * Check if a given object implements the SendTipNotificationActionData interface.
 */
export function instanceOfSendTipNotificationActionData(value: object): value is SendTipNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;
    isInstance = isInstance && "senderUserId" in value && value["senderUserId"] !== undefined;
    isInstance = isInstance && "receiverUserId" in value && value["receiverUserId"] !== undefined;
    isInstance = isInstance && "tipTxSignature" in value && value["tipTxSignature"] !== undefined;

    return isInstance;
}

export function SendTipNotificationActionDataFromJSON(json: any): SendTipNotificationActionData {
    return SendTipNotificationActionDataFromJSONTyped(json, false);
}

export function SendTipNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendTipNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'senderUserId': json['sender_user_id'],
        'receiverUserId': json['receiver_user_id'],
        'tipTxSignature': json['tip_tx_signature'],
    };
}

export function SendTipNotificationActionDataToJSON(value?: SendTipNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'sender_user_id': value.senderUserId,
        'receiver_user_id': value.receiverUserId,
        'tip_tx_signature': value.tipTxSignature,
    };
}

